module.exports = require("./ff-Latn-NG.d.ts");